import React, { useState, useEffect } from 'react';
import ContentPage from './contentPage/contentPage';
import PageWrapper from 'src/containers/pageWrapper/pageWrapper';
import { BtnForm, FormRow } from '../forms/Forms';
import CodeCheckResult from './codeCheckResult/codeCheckResult';
import FormattedTextField, {
  PostalFormat,
} from '../forms/textField/formattedTextField';
import { useDispatch, useSelector } from 'react-redux';
import { GlobalState } from 'src/logic/reducers';
import { orderActions } from 'src/logic/order';

const Range = () => {
  const [failed, setFailed] = useState<boolean>();
  const [code, setCode] = useState('');
  const [city, setCity] = useState('');
  const [cities, setCities] = useState<string[]>([]);
  const dispatch = useDispatch();
  const postalCodes = useSelector((gs: GlobalState) => gs.order.postalCodes);

  const checkingPostalCode = (postalCode: string) => {
    const savedPostalCode = postalCodes.find((code) => code.postalCode === postalCode)
    if (!savedPostalCode) {
      dispatch(orderActions.checkPostalCode.request(postalCode));
    } else {
      setCities(savedPostalCode.cities);
      if (savedPostalCode.cities.length <= 1) {
        const selectedCity = savedPostalCode.cities[0] || '';
        setCity(selectedCity);
        setFailed(!savedPostalCode.isAvailable);
      }
    }
  }

  useEffect(() => {
    setFailed(undefined);
    setCity('');
    setCities([]);
  }, [code]);

  useEffect(() => {
    if (code.length === 6) {
      const postalCodeData = postalCodes.find((postalCode) => postalCode.postalCode === code);
      if (postalCodeData) {
        setCities(postalCodeData.cities);
        // if (postalCodeData.cities.length <= 1) {
        //   const selectedCity = postalCodeData.cities[0] || '';
        //   setCity(selectedCity);
        //   setFailed(!postalCodeData.isAvailable);
        // }
      }
    }
  }, [postalCodes])

  const handleCheck = () => {
    if (cities.length > 1 && city) {
      const postalCodeData = postalCodes.find((pc) => pc.postalCode === code);
      const isAvailable = postalCodeData?.cities.some(
        (c) => c.toLowerCase() === city.toLowerCase()
      );
      setFailed(!isAvailable);
    } else {
      checkingPostalCode(code);
    }
  };

  return (
    <ContentPage>
      <PageWrapper>
        <div className="split">
          <div className='rangeBox'>
            <h1 className="h1">Zasięg</h1>
            <h2 className="h2">
              Działamy na terenie <em>całej Polski</em>.
            </h2>
            <h3 className="deliveryHeader">
              Nie jesteś pewien, czy do Ciebie też dojeżdżamy?
              <br/>
              Podaj nam swój kod pocztowy i sprawdź:
            </h3>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleCheck();
              }}
            >
              <FormRow align="top">
                <FormattedTextField
                  value={code}
                  format={PostalFormat}
                  onChange={setCode}
                  label="kod pocztowy"
                ></FormattedTextField>
                {cities.length > 0 && (
                  <div style={{ position: 'relative', width: '100%', margin: '0 3rem 3rem 0' }}>
                    <select
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '27px 20px 13px 20px',
                        fontFamily: 'Rubik, sans-serif',
                        fontWeight: 500,
                        fontSize: '14px',
                        lineHeight: '20px',
                        border: 'none',
                        borderRadius: '6px',
                        backgroundColor: '#F3F3F3',
                        color: city ? 'inherit' : 'rgba(0,0,0,0.3)',
                        outline: 'none',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        cursor: 'pointer',
                      }}
                    >
                      <option value="">Wybierz miasto</option>
                      {cities.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                    <label style={{
                      position: 'absolute',
                      top: '8px',
                      left: '20px',
                      fontSize: '10px',
                      textTransform: 'uppercase',
                      fontFamily: 'Rubik, sans-serif',
                      color: 'rgba(0,0,0,0.3)',
                      pointerEvents: 'none',
                    }}>Miasto</label>
                  </div>
                )}
                <BtnForm type="black" disabled={code.length < 6 || (cities.length > 1 && !city)}>
                  Sprawdź
                </BtnForm>
              </FormRow>
            </form>
            {failed !== undefined && (
              <CodeCheckResult failed={failed} code={code} city={city} />
            )}
          </div>
          <div className="map">
            <img src="/images/mapka.png" alt="Mapa zasięgu" />
          </div>
        </div>
      </PageWrapper>
    </ContentPage>
  );
};
export default Range;
